import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseAppComponent } from './base-app/base-app.component';

const routes: Routes = [
  {
    path: '',
    component: BaseAppComponent,
    children: [
      {
        path: 'contactus',
        loadChildren: () =>
          import('../contact-us/contact-us.module').then(
            (mod) => mod.ContactUsPageModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../dashboard/dashboard.module').then(
            (mod) => mod.DashboardPageModule
          ),
      },
      // {
      //   path: 'welcome',
      //   loadChildren: () => import('../welcome/welcome.module').then(mod => mod.WelcomePageModule)
      // },
      {
        path: 'integration',
        loadChildren: () =>
          import('../integration/integration.module').then(
            (m) => m.IntegrationPageModule
          ),
      },
      {
        path: 'instances',
        loadChildren: () =>
          import('../instances/instance.module').then((m) => m.InstancesModule),
      },
      {
        path: 'marketplace',
        loadChildren: () =>
          import('../marketplace/marketplace.module').then(
            (m) => m.MarketplaceModule
          ),
      },

      // {
      //   path: 'subscribe',
      //   loadChildren: () => import('../subscribe-now/subscribe-now.module').then( m => m.SubscribeNowPageModule)
      // },

      {
        path: 'api-catalog',
        loadChildren: () =>
          import('../api-catalog/api-catalog.module').then(
            (m) => m.ApiCatalogPageModule
          ),
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('../organization/organization.module').then(
            (m) => m.OrganizationPageModule
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('../user/user.module').then((m) => m.UserPageModule),
      },
      {
        path: 'catalog-manager',
        loadChildren: () =>
          import('../catalog-manager/catalog-manager.module').then(
            (m) => m.CatalogManagerPageModule
          ),
      },
      {
        path: 'user-group',
        loadChildren: () =>
          import('../user-group/user-group.module').then(
            (m) => m.UserGroupPageModule
          ),
      },
      {
        path: 'category',
        loadChildren: () =>
          import('../category/category.module').then(
            (m) => m.CategoryPageModule
          ),
      },
      {
        path: 'brand',
        loadChildren: () =>
          import('../brand/brand.module').then((m) => m.BrandPageModule),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('../my-account/my-account.module').then(
            (m) => m.MyAccountPageModule
          ),
      },
      {
        path: 'product-updates',
        loadChildren: () =>
          import('../update-views/update-views.module').then(
            (m) => m.UpdateViewsPageModule
          ),
      },
      {
        path: 'product',
        loadChildren: () =>
          import('../product/product.module').then((m) => m.ProductPageModule),
      },
      {
        path: 'notauthorized',
        loadChildren: () =>
          import('../notauthorised/notauthorised.module').then(
            (m) => m.NotauthorisedModule
          ),
      },
      {
        path: 'accounting-billing',
        loadChildren: () =>
          import('../accounting-billing/accounting-billing.module').then(
            (m) => m.AccountingBillingPageModule
          ),
      },
      {
        path: 'change-password-new',
        loadChildren: () =>
          import('../change-password-new/change-password-new.module').then(
            (m) => m.ChangePasswordNewPageModule
          ),
      },
      {
        path: 'database-env',
        loadChildren: () =>
          import('../database-env/database-env.module').then(
            (m) => m.DatabaseEnvPageModule
          ),
      },
      {
        path: 'datalake-env',
        loadChildren: () =>
          import('../datalake-env/datalake-env.module').then(
            (m) => m.DataLakeEnvPageModule
          ),
      },
      {
        path: 'ml-environment',
        loadChildren: ()=>
          import('../ml-env/ml-env.module').then(
            (m) =>m.MlEnvModule
          ),
      },
      {
        path: 'activity-logs',
        loadChildren: () =>
          import('../activity-logs/activity-logs.module').then(
            (m) => m.ActivityLogsPageModule
          ),
      },
      {
        path: 'config',
        loadChildren: () =>
          import('../config/config.module').then((m) => m.ConfigPageModule),
      },
      {
        path: 'multi-factor-auth',
        loadChildren: () =>
          import('../multi-factor-auth/multi-factor-auth.module').then(
            (m) => m.MultiFactorAuthPageModule
          ),
      },
      {
        path: 'vendor-list',
        loadChildren: () =>
          import('../vendor-list/vendor-list.module').then(
            (m) => m.VendorListModule
          ),
      },
      {
        path: 'data-source-management',
        loadChildren: () =>
          import('../goldFinch/data-source/data-source.module').then(
            (m) => m.DataSourcePageModule
          ),
      },
      {
        path: 'gold-finch-chat',
        loadChildren: () =>
          import('../gold-finch-chat/gold-finch-chat.module').then(
            (m) => m.GoldFinchChatModule
          ),
      },

      // {
      //   path: 'about-us',
      //   loadChildren: () => import('../about-us/about-us.module').then(m => m.AboutUsPageModule)
      // },
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BaseAppPageRoutingModule {}
